import React from 'react';
import DOMPurify from 'dompurify';

import { SiteConfigManager } from '@atlas/core';

import useSeoPage from 'components/SeoPage/useSeoPage';

const SeoPageText = () => {
  const seoPageContext = useSeoPage();

  const currentPageText = () => {
    if (seoPageContext) {
      return seoPageContext.currentPage?.data;
    }
    return '';
  };

  if (!SiteConfigManager.getConfig('config.config.seo.enable_seo_text') || !currentPageText()) {
    return null;
  }

  return (
    <div
      className="seo-page-text"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(currentPageText(), { KEEP_CONTENT: true }),
      }}
    />
  );
};

export default SeoPageText;
